export const OUTBOUND_DATE = 'outboundDate';
export const INBOUND_DATE = 'inboundDate';
export const OUTBOUND = 'outbound';
export const INBOUND = 'inbound';
export const BOOKING_ITEMS = 'bookingItems';
export const BOTH = 'both';
export const directions = [OUTBOUND, INBOUND];

export const BOOKING_WINDOW_MINUTES = 30;

export const ANY_BELGIAN_STATION_UIC = '88999999';
export const ANY_BELGIAN_STATION_SHORT_TARIFF_CODE = 'ABS';
export const ADS_THROUGH_BRUSSELS_UIC = '84999999';
export const ADS_THROUGH_BRUSSELS_SHORT_TARIFF_CODE = 'ADS';
export const AMSTERDAM_UIC = '8400058';
export const ROTTERDAM_UIC = '8400530';

export const ANY_BELGIAN_STATION_NAME = 'Any Belgian Station';
export const ADS_THROUGH_BRUSSELS_NAME = 'Any Dutch Station';
export const AMSTERDAM_NAME = 'Amsterdam Central';

export const MAP_ADD_ONS_STATION_UIC_TO_NAMES = {
  [ANY_BELGIAN_STATION_UIC]: ANY_BELGIAN_STATION_NAME,
  [ADS_THROUGH_BRUSSELS_UIC]: ADS_THROUGH_BRUSSELS_NAME
};

export const SBNS_SERVICE_TYPE = 'SBNS';

export const POINT_OF_SALES_KEY = 'POS';

export const displaySeatsLeftBounds = [1, 9];
export const PRIMARY_LOYALTY_ACCOUNT_ADDITIONAL_DETAILS_KEY = 'primary_loyalty_account';
export const RECEIPT_DATA_ADDITIONAL_DETAILS_KEY = 'receipt_data';
export const OPERATIONAL_REMARK_ADDITIONAL_DETAILS_KEY = 'EDCS';

export const HOTEL_STATUSES = {
  CANCELLED: 'Cancelled',
  NOT_CANCELLED: 'Confirmed',
  NOT_FOUND: 'Not found'
};

export const HOTEL_PRODUCT_TYPE = {
  HOTELS: 'hotels',
  PACKAGES: 'packages'
};

export const EXTERNAL_REFERENCES = {
  EHL: 'EHL'
};

export const TRAVEL_PASS_REFUNDED = 'Travel Pass VAT refunded';

export const PACKAGE_HOTEL_MARGIN_PERCENTAGE = 18;

export const HOTEL_ADDITIONAL_DETAILS_KEYS = {
  BOOKER_SURNAME: 'booker_surname',
  EUROSTAR_REFERENCE: 'eurostar_reference',
  GUEST_COUNT: 'guest_count',
  HOTEL_ADDRESS: 'hotel_address',
  HOTEL_COUNTRY: 'hotel_country',
  HOTEL_ID: 'hotel_id',
  HOTEL_NAME: 'hotel_name',
  NUMBER_OF_NIGHTS: 'number_of_nights',
  PRODUCT_TYPE: 'product_type',
  PROVIDER_SYSTEM: 'provider_system',
  ROOM_COUNT: 'room_count'
};

export const ASSISTANCE_ANIMAL_ADDITIONAL_DETAILS_KEY = 'assistance_animal';
export const PASSENGER_DISABILITY_ADDITIONAL_DETAILS_KEY = 'passenger_disability';
export const MEET_AND_ASSIST_ADDITIONAL_DETAILS_KEY = 'MAAS';

export const THALYS_INVENTORY_CLASSES = {
  THALYS_STANDARD: 'TB',
  THALYS_COMFORT: 'TH',
  THALYS_PREMIUM: 'TA',
  THALYS_WHEELCHAIR_SPACE: 'TW',
  THALYS_COMPANION: 'TC'
};

export const MISSED_DEPARTURE_RE_ACCOMMODATE_ADDITIONAL_DETAILS_KEY = 'missed_departure_reaccommodate_data';
export const FLOW_FORWARD_RE_ACCOMMODATE_ADDITIONAL_DETAILS_KEY = 'flow_forward_reaccommodate_data';
export const MULTI_JOURNEY_KEY = 'multi_journey';
export const SEGMENT_KEY = 'segment_';
export const JOURNEY_KEY = 'journey_';

export const DEFAULT_LANGUAGE = 'EN';
export const LANGUAGE_KEY = 'customer_language';
export const VAT_ADDITIONAL_DETAILS_KEYS = {
  VAT_NUMBER: 'vat_number'
};
export const PAX_DESCRIPTIONS = {
  adults: 'adultsDescriptionSecondary',
  children: 'childrenDescriptionSecondary',
  youths: 'youthsDescription',
  seniors: 'seniorsDescription',
  seniors60To64: 'seniorsDescription.seniors60To64',
  seniors65Plus: 'seniorsDescription.seniors65Plus'
};

export const NO_VAT_PRODUCT_CODE = 'NOVAT';
export const MICE_GROUP_PRODUCT = 'MICE Groups';

export const LOYALTY_COMPANION_PRODUCT_CODES = ['RED_LOYALTY_COMP_STD', 'RED_LOYALTY_COMP_PLU', 'LOYALTY_COMP_PLUS', 'LOYALTY_COMP_STAND'];
export const NEW_FARE_CONDITION_DATE_ON_EXCHANGE = '2024-04-23';

export const DETAILS_CAPTURED = {
  CAPTURED: 'CAPTURED',
  NOT_CAPTURED: 'NOT_CAPTURED',
  PARTIAL: 'PARTIAL'
};

export const GDS = 'GDS';
